import { TextField } from "@mui/material";
import { memo } from "react";

const Integer64Entry = memo(({ elementName, fieldLabel, startingValue, setResourceState, marginTop, required }) => {
    return <TextField error={required && !startingValue}
        style={{ width: "100%", marginTop: marginTop || "12px" }} 
        className="inputField" type='number' label={fieldLabel} size="small" variant='outlined'
        value={startingValue || ""}
        onChange={(e) => {
            setResourceState(prevState => { return { ...prevState, [elementName]: e.target.value } });
        }} />
});

export default Integer64Entry;